import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.RATINGS_CLINICAL_REVIEWS_GLOBAL_LIST}`,
            render: () => import("../../Pages/Core/PersonsServed/ClinicalReviewsList.svelte"),
            title: "Clinical Reviews"
        }
    ]
};

export default routerConfig;